import { render, staticRenderFns } from "./UKY1.vue?vue&type=template&id=38091123&scoped=true"
import script from "./UKY1.vue?vue&type=script&lang=js"
export * from "./UKY1.vue?vue&type=script&lang=js"
import style0 from "./UKY1.vue?vue&type=style&index=0&id=38091123&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38091123",
  null
  
)

export default component.exports